import InviteEmployeeModal from './InviteEmployeeModal';

export default InviteEmployeeModal;
